import api from '@pray/shared/utils/api';

export type FindingSeverity = 'critical' | 'high' | 'medium' | 'low';

export type EmailHealthFinding = {
  id: string;
  category: string;
  severity: FindingSeverity;
  title: string;
  description: string;
  recommendation: string;
};

export type EmailHealthScores = {
  overall: number;
  authentication: number;
  engagement: number;
  list_health: number;
  compliance: number;
};

export type EmailHealthDiagnosticSummary = {
  grade: string;
  total_findings: number;
  critical_count: number;
  high_count: number;
  medium_count: number;
  low_count: number;
};

export type EmailHealthDiagnostic = {
  org_id: string;
  org_name: string;
  artist_id: string;
  scores: EmailHealthScores;
  summary: EmailHealthDiagnosticSummary;
  findings: EmailHealthFinding[];
  last_refreshed: string | null;
};

export type GetEmailHealthDiagnosticParams = {
  orgId: string;
};

export async function getEmailHealthDiagnostic({
  orgId,
}: GetEmailHealthDiagnosticParams): Promise<EmailHealthDiagnostic> {
  const url = `/web/studio/email-health/${orgId}`;
  const response = await api.executeGetRequest<{ data: EmailHealthDiagnostic }>(url);
  return response.data.data;
}
